import { Controller } from "@hotwired/stimulus"

// Manages the submission checklist — disables the submit button until all
// checkboxes are checked and the bundle is ready for submission.
// Satisfied items are pre-checked and disabled by the server; unsatisfied
// items must be manually acknowledged.
//
// Exposes `allChecked` for the confirm controller outlet integration.
export default class extends Controller {
  static targets = ["checkbox", "submitButton"]
  static values = { ready: { type: Boolean, default: true } }

  connect() {
    this.updateSubmitButton()
  }

  toggle() {
    this.updateSubmitButton()
  }

  get allChecked() {
    return this.checkboxTargets.every((cb) => cb.checked)
  }

  updateSubmitButton() {
    if (!this.hasSubmitButtonTarget) return
    this.submitButtonTarget.disabled = !(this.readyValue && this.allChecked)
  }
}
